import '../Stylesheets/Parallax3.css'; // Import your stylesheet

export default function Parallax3() {
  return (
    <div className="parallax3"></div> // Standalone parallax section
  );
}
